export function setString(vm: any, path: string, value: string) {
  const prop = vm?.string?.(path);
  if (prop) prop.value = value;
}

export function setNumber(vm: any, path: string, value: number) {
  const prop = vm?.number?.(path);
  if (prop) prop.value = value;
}

export function setBool(vm: any, path: string, value: boolean) {
  const prop = vm?.boolean?.(path);
  if (prop) prop.value = value;
}

export function setEnum(vm: any, path: string, value: string) {
  const prop = vm?.enum?.(path);
  if (prop) prop.value = value;
}

/** Fire a Rive trigger if it exists. Returns true when fired successfully. */
export function fireTrigger(vm: any, name: string): boolean {
  const trigger = vm?.trigger?.(name);
  if (trigger && typeof trigger.trigger === 'function') {
    trigger.trigger();
    return true;
  }
  return false;
}
